import { COMPOSE_CAMPAIGNS } from '../../views/common/FeatureCodeConstants.js';

const CampaignCollection = Backbone.Collection.extend({

  sync(method, collection, options) {
    let params;

    if (method == 'read') {
      const featureStatus = window.js_featurMngr.getFeatureStatus(COMPOSE_CAMPAIGNS);

      if (featureStatus == 'restricted' || featureStatus == 'limited') {
        options.success([]);
        return;
      }

      params = _.omit($.extend(true, {}, options), ['parse', 'success', 'error', 'silent', 'remove', 'reset']);

      return Sendible.Connect.getCampaigns(
        params,
        (data) => {
          if (data?.result) {
            const results = this.processResults(data.result, params.activeCampaignsOnly);
            options.success(results);
          }
        },
        () => { options.success([]); },
      );
    }
  },

  processResults(results, activeCampaignsOnly) {
    if (!results || !results?.length || !results[0]?.name) {
      return [];
    }
    const sortedResults = results.sort((a, b) => a.name.localeCompare(b.name));

    if (activeCampaignsOnly) {
      return sortedResults.filter((campaign) => campaign.status === 'active');
    }

    return sortedResults;
  },
});

export default CampaignCollection;
